import React, { createContext, useContext, useState, useMemo, useCallback } from 'react';

const PromptContext = createContext();

export const usePromptContext = () => useContext(PromptContext);

export const PromptProvider = ({ children }) => {
    const [contextSubmitPrompt , setPrompt] = useState("");

    const updatePrompt = useCallback((newPrompt) => {
        setPrompt(newPrompt);
    }, []);

    const value = useMemo(() => ({ contextSubmitPrompt, updatePrompt }), [contextSubmitPrompt, updatePrompt]);

    return (
        <PromptContext.Provider value={value}>
            {children}
        </PromptContext.Provider>
    );
};
